import { service } from '@ember/service';
import Route from '@ember/routing/route';
// This is for types. Anything we have custom may show an error.
import type { Store as StoreService } from '@warp-drive/core';
import { validateResetPasswordTokenRequest } from 'tio-data/requests/login';

export default class ResetPasswordRoute extends Route {
  @service declare store: StoreService;

  queryParams = {
    token: { refreshModel: true, replace: true },
  };

  async model() {
    const query = location.search;
    const params = new URLSearchParams(query);
    const token = params.get('token');

    if (!token) {
      return { error: 'Invalid token' };
    }

    let validationRes: { success?: boolean } | undefined;
    try {
      const response = await this.store.request(validateResetPasswordTokenRequest(token));
      validationRes = response.content as { success?: boolean };
    } catch {
      // Legacy adapter swallowed errors and returned { success: false } —
      // preserve that posture so an invalid/expired token still routes
      // through the error branch below.
      validationRes = { success: false };
    }

    if (!validationRes?.success) {
      return { error: 'Invalid token' };
    }
  }
}
